import { ACTION_TYPES } from './Loading.constant';

export const actionOpenLoading = () => ({
    type: ACTION_TYPES.OPEN_LOADING,
});

export const actionCloseLoading = () => ({
    type: ACTION_TYPES.CLOSE_LOADING,
});
